import { CARD_SPENDING_CONTROLS_ROUTE, TabConfig } from '../../../common';
import lang from '../../../lang/spendingControl';

export const tabConfig = (): TabConfig[] => [
    {
        label: lang.TABS.SPENDING_CONTROL,
        link: CARD_SPENDING_CONTROLS_ROUTE,
    },
];
